<div [ngClass]="getLevelClass()">
  <div class="iterate-collection">
    <basic-label></basic-label>
    <div class="iterate-collection__item" *ngFor="let currentItem of arrayProp; let i = index">
      <div
        *ngIf="arrayProp.length > 1"
        class="iterate-collection__control-panel iterate-collection__control-panel--added"
      >
        <div
          class="iterate-collection__item-container iterate-collection__item-container--beneficiary"
          *ngIf="'Beneficiary'.match(questionItem.arrayType)"
        >
          <div class="iterate-collection__control" (click)="toggleElement(i)">
            <div
              class="iterate-collection__toggle"
              [ngClass]="isActive(i) ? 'iterate-collection__toggle--collapse' : 'iterate-collection__toggle--expand'"
            ></div>
            <div class="iterate-collection__title">Beneficiary Added</div>
          </div>
          <div class="beneficiary-summary" *ngIf="'Beneficiary'.match(questionItem.arrayType)">
            <div *ngIf="arrayProp[i].person.fullName !== ' '" class="beneficiary-summary__item">
              {{ arrayProp[i].person.fullName }}
            </div>
            <div class="beneficiary-summary__item">Share of benefit: {{ arrayProp[i].ratio }}%</div>
          </div>
        </div>
        <button
          type="button"
          class="button button--small button--secondary button--gray"
          [class.button--disabled]="isDisabled"
          [disabled]="isDisabled"
          (click)="remove(questionItem.prop, i, questionItem.removeFuncSuffix)"
        >
          Delete
        </button>
      </div>
      <div
        class="iterate-body level-1"
        [hidden]="'Beneficiary'.match(questionItem.arrayType) && !(isActive(i) || isServer)"
      >
        <ng-container *ngFor="let childQuestion of questionItem.children">
          <ng-container *ngIf="childQuestion.isShown(i)">
            <div class="application-form__traverse-container">
              <div [id]="'label-scroll-point__' + childQuestion.id + '[' + i + ']'"></div>
              <application-form-question-traverse
                #arrayChildren
                [childQuestion]="childQuestion"
                [loopIndex]="i"
              ></application-form-question-traverse>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div *ngIf="enableAddAnother" class="iterate-collection__control-panel iterate-collection__control-panel--add">
      <button
        cp-button
        theme="blue-alt"
        variant="primary"
        size="regular"
        [disabled]="isDisabled"
        (click)="add(questionItem.prop, questionItem.arrayType, questionItem.addFuncSuffix)"
      >
        {{ linkLabel }}
      </button>
    </div>
  </div>
</div>
